import { unifiedAgentEvent } from './unifiedAgentEvent'

export const unifiedAgentBuildPromptSentLogEvent = unifiedAgentEvent<{
  session_id: string
  prompt_number: number
  agent_id?: number
}>('Unified_Agent_Build_Prompt_Sent')
